const it = {
  // ============================================================
  // COMMON — Condiviso in tutta l'applicazione
  // ============================================================
  common: {
    loading: 'Caricamento...',
    error: 'Errore',
    save: 'Salva',
    cancel: 'Annulla',
    delete: 'Elimina',
    edit: 'Modifica',
    create: 'Crea',
    add: 'Aggiungi',
    remove: 'Rimuovi',
    close: 'Chiudi',
    confirm: 'Conferma',
    apply: 'Applica',
    reset: 'Ripristina',
    search: 'Cerca',
    filter: 'Filtra',
    clear: 'Cancella',
    back: 'Indietro',
    next: 'Avanti',
    previous: 'Precedente',
    submit: 'Invia',
    update: 'Aggiorna',
    refresh: 'Aggiorna',
    export: 'Esporta',
    import: 'Importa',
    download: 'Scarica',
    upload: 'Carica',
    print: 'Stampa',
    copy: 'Copia',
    yes: 'Sì',
    no: 'No',
    ok: 'OK',
    done: 'Fatto',
    select: 'Seleziona',
    selectAll: 'Seleziona tutto',
    deselectAll: 'Deseleziona tutto',
    noResults: 'Nessun risultato trovato',
    noData: 'Nessun dato disponibile',
    required: 'Obbligatorio',
    optional: 'Facoltativo',
    actions: 'Azioni',
    details: 'Dettagli',
    overview: 'Panoramica',
    summary: 'Riepilogo',
    total: 'Totale',
    all: 'Tutti',
    none: 'Nessuno',
    name: 'Nome',
    type: 'Tipo',
    status: 'Stato',
    date: 'Data',
    time: 'Ora',
    description: 'Descrizione',
    notes: 'Note',
    comments: 'Commenti',
    category: 'Categoria',
    priority: 'Priorità',
    nation: 'Nazione',
    country: 'Paese',
    email: 'E-mail',
    phone: 'Telefono',
    address: 'Indirizzo',
    location: 'Posizione',
    coordinates: 'Coordinate',
    latitude: 'Latitudine',
    longitude: 'Longitudine',
    from: 'Da',
    to: 'A',
    createdAt: 'Creato',
    updatedAt: 'Aggiornato',
    createdBy: 'Creato da',
    modifiedBy: 'Modificato da',
    active: 'Attivo',
    inactive: 'Inattivo',
    enabled: 'Abilitato',
    disabled: 'Disabilitato',
    showing: 'Visualizzazione',
    of: 'di',
    page: 'Pagina',
    perPage: 'per pagina',
    rows: 'righe',
    items: 'elementi',
    results: 'risultati',
    sortBy: 'Ordina per',
    ascending: 'Crescente',
    descending: 'Decrescente',
    viewAll: 'Vedi tutto',
    viewDetails: 'Vedi dettagli',
    goBack: 'Torna indietro',
    learnMore: 'Scopri di più',
    seeMore: 'Vedi altro',
    showMore: 'Mostra di più',
    showLess: 'Mostra meno',
    expandAll: 'Espandi tutto',
    collapseAll: 'Comprimi tutto',
    copied: 'Copiato!',
    saved: 'Salvato!',
    deleted: 'Eliminato!',
    updated: 'Aggiornato!',
    created: 'Creato!',
    success: 'Successo',
    warning: 'Avvertimento',
    info: 'Info',
    danger: 'Pericolo',
    unknown: 'Sconosciuto',
    notAvailable: 'N/D',
    never: 'Mai',
    today: 'Oggi',
    yesterday: 'Ieri',
    tomorrow: 'Domani',
    now: 'Ora',
    ago: 'fa',
    justNow: 'proprio ora',
    minutesAgo: '{{count}} min fa',
    hoursAgo: '{{count}} h fa',
    daysAgo: '{{count}} g fa',
    monthsAgo: '{{count}} mesi fa',
    id: 'ID',
    version: 'Versione',
    language: 'Lingua',
    theme: 'Tema',
    darkMode: 'Modalità scura',
    lightMode: 'Modalità chiara',
    failedToLoad: 'Impossibile caricare i dati',
    failedToSave: 'Impossibile salvare',
    failedToDelete: 'Impossibile eliminare',
    failedToUpdate: 'Impossibile aggiornare',
    confirmDelete: 'Conferma l\'eliminazione di questo elemento?',
    confirmAction: 'Conferma l\'operazione?',
    unsavedChanges: 'Sono presenti modifiche non salvate. Conferma di voler uscire?',
    pageNotFound: '404 - Pagina non trovata',
    pageNotFoundDesc: 'La pagina cercata non esiste.',
    backToDashboard: 'Torna alla dashboard',
    characters: 'caratteri',
    maxCharacters: 'Massimo {{max}} caratteri',
    remaining: '{{count}} rimanenti',
    selected: '{{count}} selezionati',
    of_total: '{{count}} di {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Intestazione, barra laterale, menu
  // ============================================================
  nav: {
    dashboard: 'Dashboard',
    requests: 'Richieste',
    transports: 'Trasporti',
    myPatients: 'I miei pazienti',
    statistics: 'Statistiche',
    flow: 'Flusso',
    resources: 'Resources',
    exercise: 'Esercitazione',
    administration: 'Amministrazione',
    map: 'Mappa',
    info: 'Info',
    users: 'Utenti',
    assets: 'Mezzi di trasporto',
    hubs: 'Hub',
    treatmentFacilities: 'Strutture sanitarie',
    patientImport: 'Importazione pazienti',
    assetTemplates: 'Modelli mezzi',
    dayTemplates: 'Modelli giornalieri',
    announcementTicker: 'Barra annunci',
    exerciseStatistics: 'Statistiche dell\'esercitazione',
    settings: 'Impostazioni',
    auditLog: 'Registro di audit',
    exerciseControl: 'Controllo dell\'esercitazione',
    dataSync: 'Sincronizzazione dati',
    documentation: 'Documentazione',
    support: 'Supporto',
    about: 'Informazioni',
    assetContracts: 'Asset Contracts',
    notifications: 'Notifiche',
    schedules: 'Orari',
    capacityPlanning: 'Pianificazione capacità',
    transportPlanning: 'Pianificazione trasporti',
    transportBooking: 'Prenotazione trasporti',
    flowDiagram: 'Diagramma di flusso',
    changePassword: 'Cambia password',
    missions: 'Missioni',
    startPoints: 'Punti di partenza',
    hospital: 'Ospedale',
  },

  // ============================================================
  // AUTH — Accesso, password, sessione
  // ============================================================
  auth: {
    login: 'Accedi',
    logout: 'Esci',
    logoutNow: 'Esci ora',
    loggingIn: 'Accesso in corso...',
    loginFailed: 'Accesso non riuscito',
    email: 'E-mail',
    password: 'Password',
    username: 'Nome utente',
    enterEmail: 'Inserisca il Suo indirizzo e-mail',
    enterPassword: 'Inserisca la Sua password',
    enterUsername: 'Inserisca il Suo nome utente',
    forgotPassword: 'Password dimenticata?',
    forgotPasswordTitle: 'Password dimenticata',
    forgotPasswordDesc: 'Inserisca il Suo nome utente e il Suo indirizzo e-mail. Se entrambi corrispondono, gli amministratori saranno avvisati per reimpostare la Sua password.',
    requestPasswordReset: 'Richiedi reimpostazione password',
    sending: 'Invio in corso...',
    backToLogin: 'Torna all\'accesso',
    pleaseWait: 'Attendere prima di riprovare.',
    requestFailed: 'Richiesta non riuscita',
    credentialsMatch: 'Se le credenziali corrispondono, gli amministratori sono stati avvisati.',
    forAccess: 'Per ottenere l\'accesso, contatti il Suo amministratore di sistema.',
    changePassword: 'Cambia password',
    currentPassword: 'Password attuale',
    newPassword: 'Nuova password',
    confirmPassword: 'Conferma password',
    passwordChanged: 'Password modificata con successo',
    passwordMismatch: 'Le password non corrispondono',
    passwordTooShort: 'La password deve contenere almeno 8 caratteri',
    changingPassword: 'Modifica in corso...',
    mustChangePassword: 'È necessario cambiare la password prima di continuare.',
    sessionExpiring: 'Sessione in scadenza',
    sessionExpireText: 'La Sua sessione scadrà tra <strong>{{time}}</strong>. Salvi il lavoro e acceda nuovamente per continuare.',
    dismiss: 'Chiudi',
    switchNation: 'Cambia nazione',
    returnTo: 'Torna a {{nation}}',
    viewingAs: 'Visualizzazione come',
    loggedInAs: 'connesso come {{nation}}',
    trainingMode: 'SOLO A SCOPO DI ADDESTRAMENTO',
    dedication: 'Creato con passione e dedizione per la professione',
  },

  // ============================================================
  // ROLES — Ruoli utente ed etichette
  // ============================================================
  roles: {
    admin: 'Amministratore di sistema',
    excon: 'Controllore dell\'esercitazione',
    eu: 'Coordinatore UE',
    planner: 'Pianificatore',
    hub: 'Gestore hub',
    nation: 'Nazione',
    readOnly: 'Sola lettura',
    systemAdmin: 'Amministratore di sistema',
    transportPlanner: 'Pianificatore trasporti',
    systemRoles: 'Ruoli di sistema',
  },

  // ============================================================
  // STATUS — Stati delle richieste, offerte, missioni
  // ============================================================
  status: {
    draft: 'Bozza',
    underReview: 'In revisione',
    published: 'Pubblicata',
    underSelection: 'In selezione',
    accepted: 'Accettata',
    planned: 'Pianificata',
    inTransit: 'In transito',
    completed: 'Completata',
    closed: 'Chiusa',
    withdrawn: 'Ritirata',
    pending: 'In attesa',
    rejected: 'Rifiutata',
    cancelled: 'Annullata',
    active: 'Attiva',
    inactive: 'Inattiva',
    review: 'Revisione',
    selection: 'Selezione',
    transit: 'Transito',
  },

  // ============================================================
  // CATEGORIES — Categorie di richieste
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Personale',
    material: 'Materiale',
    equipment: 'Attrezzatura',
    other: 'Altro',
    news: 'Notizie',
  },

  // ============================================================
  // URGENCY — Livelli di urgenza
  // ============================================================
  urgency: {
    routine: 'Ordinaria',
    priority: 'Prioritaria',
    urgent: 'Urgente',
    immediate: 'Immediata',
  },

  // ============================================================
  // ASSETS — Tipi di mezzi di trasporto
  // ============================================================
  assetTypes: {
    train: 'Treno',
    ship: 'Nave',
    aircraft: 'Aeromobile',
    bus: 'Autobus',
    ambulance: 'Ambulanza',
    drone: 'Drone',
    helicopter: 'Elicottero',
    ferry: 'Traghetto',
    other: 'Altro',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Dashboard',
    goodMorning: 'Buongiorno',
    goodAfternoon: 'Buon pomeriggio',
    goodEvening: 'Buonasera',
    lastLogin: 'Ultimo accesso',
    infrastructure: 'Infrastruttura',
    transportAssets: 'Mezzi di trasporto',
    treatmentFacilities: 'Strutture sanitarie',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Statistiche delle richieste',
    viewAllRequests: 'Visualizza tutte le richieste',
    availableAssets: 'Mezzi disponibili',
    seated: 'Seduti',
    lying: 'Sdraiati',
    intensive: 'Terapia intensiva',
    notifications: 'Notifiche',
    markAllRead: 'Segna tutto come letto',
    noNotifications: 'Nessuna notifica al momento',
    notifiedWhenActivity: 'Riceverà una notifica quando si verificheranno nuove attività',
    viewDetailsBtn: 'Vedi dettagli',
    nationUsers: 'Utenti nazionali',
    user: 'Utente',
    roles: 'Ruoli',
    noUsersFound: 'Nessun utente trovato',
    participatingNations: 'Nazioni partecipanti',
    exerciseDisclaimer: 'Questo sistema è destinato esclusivamente all\'esercitazione. Inserire solo dati simulati dell\'esercitazione. I flussi di lavoro sono adattati allo scenario dell\'esercitazione e possono differire dalle procedure reali. Le norme di sicurezza informatica e protezione dei dati restano pienamente applicabili.',
    notConfigured: 'Non configurato',
    requestCount: '{{count}} richiesta/e',
    clickToView: 'Clicca per visualizzare',
    systemAdministration: 'Amministrazione di sistema',
    exerciseControlTitle: 'Controllo dell\'esercitazione',
    euCoordination: 'Coordinamento UE',
    transportPlanningTitle: 'Pianificazione trasporti',
    hubManagement: 'Gestione hub',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Nuova richiesta',
    myDrafts: 'Le mie bozze',
    pendingReview: 'In attesa di revisione',
    activeTransports: 'Trasporti attivi',
    myPatients: 'I miei pazienti',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Richieste',
    newRequest: 'Nuova richiesta',
    createRequest: 'Crea richiesta',
    editRequest: 'Modifica richiesta',
    requestDetail: 'Dettaglio richiesta',
    requestId: 'ID richiesta',
    fromNation: 'Dalla nazione',
    toNation: 'Alla nazione',
    requestingNation: 'Nazione richiedente',
    receivingNation: 'Nazione ricevente',
    category: 'Categoria',
    urgency: 'Urgenza',
    status: 'Stato',
    patients: 'Pazienti',
    patientCount: 'Numero di pazienti',
    offers: 'Offerte',
    offerCount: 'Numero di offerte',
    created: 'Creata',
    updated: 'Aggiornata',
    submittedBy: 'Inviata da',
    reviewedBy: 'Revisionata da',
    description: 'Descrizione',
    medicalDetails: 'Dettagli medici',
    transportDetails: 'Dettagli del trasporto',
    additionalInfo: 'Informazioni aggiuntive',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Punto di partenza',
    arrivalPoint: 'Punto di arrivo',
    estimatedDeparture: 'Partenza stimata',
    estimatedArrival: 'Arrivo stimato',
    submitForReview: 'Invia per revisione',
    publish: 'Pubblica',
    startSelection: 'Avvia la selezione',
    acceptOffer: 'Accetta l\'offerta',
    markInTransit: 'Segna come in transito',
    markCompleted: 'Segna come completata',
    closeRequest: 'Chiudi la richiesta',
    withdrawRequest: 'Ritira la richiesta',
    withdraw: 'Ritira',
    revertToDraft: 'Riporta a bozza',
    deleteRequest: 'Elimina la richiesta',
    duplicateRequest: 'Duplica la richiesta',
    createFollowUp: 'Crea richiesta consolidata',
    followUpRequest: 'Richiesta consolidata',
    parentRequest: 'Richiesta originale',
    childRequests: 'Richieste consolidate',
    noRequests: 'Nessuna richiesta trovata',
    noOffers: 'Nessuna offerta al momento',
    addPatient: 'Aggiungi paziente',
    removePatient: 'Rimuovi paziente',
    patientDetails: 'Dettagli del paziente',
    contactPerson: 'Persona di contatto',
    contactPhone: 'Telefono di contatto',
    contactEmail: 'E-mail di contatto',
    specialRequirements: 'Requisiti speciali',
    medicalEquipment: 'Attrezzatura medica',
    accompaniment: 'Accompagnamento',
    timeline: 'Cronologia',
    history: 'Storico',
    addComment: 'Aggiungi commento',
    writeComment: 'Scrivi un commento...',
    postComment: 'Pubblica commento',
    posting: 'Pubblicazione in corso...',
    noComments: 'Nessun commento al momento',
    coverageBar: 'Copertura',
    covered: 'coperti',
    uncovered: 'non coperti',
    filterByStatus: 'Filtra per stato',
    filterByCategory: 'Filtra per categoria',
    filterByNation: 'Filtra per nazione',
    searchRequests: 'Cerca richieste...',
    confirmWithdraw: 'Conferma il ritiro di questa richiesta?',
    confirmDelete: 'Conferma l\'eliminazione di questa richiesta?',
    confirmPublish: 'Conferma la pubblicazione di questa richiesta? Sarà visibile a tutte le nazioni.',
    confirmStartSelection: 'Conferma l\'avvio della selezione? Le nazioni potranno presentare offerte.',
    warningStartSelection: 'L\'avvio della selezione renderà questa richiesta visibile a tutte le nazioni partecipanti. Potranno presentare offerte per i pazienti di questa richiesta. Questa azione non può essere annullata.',
    warningMakeOffer: 'Inviando questa offerta, la Sua nazione si impegna a fornire l\'assistenza proposta. Questa azione notificherà la nazione richiedente e il controllo dell\'esercitazione.',
    saveDraft: 'Salva bozza',
    saving: 'Salvataggio in corso...',
    saveAndSubmit: 'Salva e invia',
    step: 'Passaggio {{number}}',
    generalInfo: 'Informazioni generali',
    patientInfo: 'Informazioni sul paziente',
    logisticsInfo: 'Informazioni logistiche',
    reviewSubmit: 'Revisione e invio',
    requestTitle: 'Titolo della richiesta',
    requestDescription: 'Descrizione della richiesta',
    numberOfPatients: 'Numero di pazienti',
    typeOfAssistance: 'Tipo di assistenza',
    medicalTreatment: 'Trattamento medico',
    transportAssistance: 'Assistenza al trasporto',
    both: 'Entrambi',
    treatmentOnly: 'Solo trattamento',
    transportOnly: 'Solo trasporto',
    validationErrors: 'Correggere i seguenti errori:',
    fieldRequired: 'Questo campo è obbligatorio',
    selectExitHub: 'Selezionare un hub di uscita',
    createExitHub: 'Crea hub di uscita',
    backToRequests: 'Torna alle richieste',
    noRequestsFound: 'Nessuna richiesta trovata',
    createFirstRequest: 'Crei la Sua prima richiesta per iniziare',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Offerte',
    createOffer: 'Crea offerta',
    makeOffer: 'Presenta offerta',
    manageOffers: 'Gestisci offerte',
    offerDetail: 'Dettaglio offerta',
    offerId: 'ID offerta',
    offeringNation: 'Nazione offerente',
    offerType: 'Tipo di offerta',
    treatment: 'Trattamento',
    transport: 'Trasporto',
    combined: 'Combinata',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Offerta di trattamento',
    transportOffer: 'Offerta di trasporto',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Seleziona pazienti',
    selectedPatients: 'Pazienti selezionati',
    patientSelection: 'Selezione pazienti',
    offerConfiguration: 'Configurazione offerta',
    reviewOffer: 'Verifica offerta',
    submitOffer: 'Invia offerta',
    submitting: 'Invio in corso...',
    acceptOffer: 'Accetta offerta',
    rejectOffer: 'Rifiuta offerta',
    withdrawOffer: 'Ritira offerta',
    noOffers: 'Nessuna offerta disponibile',
    noOffer: 'No Offer',
    offerStatus: 'Stato dell\'offerta',
    offerDate: 'Data dell\'offerta',
    transportAsset: 'Mezzo di trasporto',
    departureDate: 'Data di partenza',
    arrivalDate: 'Data di arrivo',
    treatmentFacility: 'Struttura sanitaria',
    capacity: 'Capacità',
    availableCapacity: 'Capacità disponibile',
    totalCapacity: 'Capacità totale',
    selectAsset: 'Seleziona mezzo',
    selectFacility: 'Seleziona struttura',
    offerNotes: 'Note dell\'offerta',
    confirmAccept: 'Conferma l\'accettazione di questa offerta?',
    confirmReject: 'Conferma il rifiuto di questa offerta?',
    extendTransport: 'Estendi trasporto',
    transportExtension: 'Estensione del trasporto',
    comparisonView: 'Vista comparativa',
    shortlist: 'Lista ristretta',
    addToShortlist: 'Aggiungi alla lista ristretta',
    removeFromShortlist: 'Rimuovi dalla lista ristretta',
    leaveConfirmTitle: 'Uscire da questa pagina?',
    leaveConfirmMessage: 'Sono presenti modifiche non salvate. Conferma di voler uscire?',
    stayOnPage: 'Resta sulla pagina',
    leavePage: 'Esci dalla pagina',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Trasporti',
    missionDetail: 'Dettaglio trasporto',
    missionId: 'ID trasporto',
    missionStatus: 'Stato del trasporto',
    createMission: 'Crea trasporto',
    overview: 'Panoramica',
    patientsTab: 'Pazienti',
    transportsTab: 'Tratte di trasporto',
    treatmentTab: 'Trattamento',
    reviewTab: 'Revisione',
    departure: 'Partenza',
    arrival: 'Arrivo',
    origin: 'Origine',
    destination: 'Destinazione',
    stops: 'Fermate',
    addStop: 'Aggiungi fermata',
    removeStop: 'Rimuovi fermata',
    stopName: 'Nome della fermata',
    stopType: 'Tipo di fermata',
    estimatedTime: 'Orario stimato',
    actualTime: 'Orario effettivo',
    asset: 'Mezzo',
    driver: 'Conducente',
    crew: 'Equipaggio',
    noMissions: 'Nessun trasporto trovato',
    completeMission: 'Completa trasporto',
    cancelMission: 'Annulla trasporto',
    startTransport: 'Avvia trasporto',
    missionChain: 'Catena di trasporto',
    linkedMissions: 'Trasporti collegati',
    handover: 'Consegna',
    handoverPoint: 'Punto di consegna',
    pickupPoint: 'Punto di raccolta',
    dropoffPoint: 'Punto di scarico',
    searchTransports: 'Cerca trasporti...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Pazienti',
    myPatients: 'I miei pazienti',
    patientId: 'ID paziente',
    firstName: 'Nome',
    lastName: 'Cognome',
    dateOfBirth: 'Data di nascita',
    age: 'Età',
    gender: 'Sesso',
    male: 'Maschile',
    female: 'Femminile',
    other: 'Altro',
    nationality: 'Nazionalità',
    diagnosis: 'Diagnosi',
    condition: 'Condizione',
    stable: 'Stabile',
    critical: 'Critico',
    serious: 'Grave',
    treatmentNeeded: 'Trattamento necessario',
    allergies: 'Allergie',
    medications: 'Farmaci',
    bloodType: 'Gruppo sanguigno',
    weight: 'Peso (kg)',
    infectious: 'Infettivo',
    mentalHealth: 'Salute mentale',
    mobility: 'Mobilità',
    ambulatory: 'Deambulante',
    wheelchair: 'Sedia a rotelle',
    stretcher: 'Barella',
    intensive: 'Terapia intensiva',
    oxygenRequired: 'Ossigeno necessario',
    ventilator: 'Ventilatore',
    medicalEscort: 'Scorta medica',
    noPatients: 'Nessun paziente trovato',
    patientDetails: 'Dettagli del paziente',
    medicalHistory: 'Anamnesi',
    travelDocuments: 'Documenti di viaggio',
    passport: 'Passaporto',
    pseudonymizedId: 'ID pseudonimizzato',
    sensitiveData: 'Dati sensibili',
    journey: 'Percorso del paziente',
    assignedTo: 'Assegnato a',
    currentLocation: 'Posizione attuale',
    importPatients: 'Importa pazienti',
    exportPatients: 'Esporta pazienti',
    seated: 'Seduto',
    lying: 'Sdraiato',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Utenti',
    createUser: 'Crea utente',
    editUser: 'Modifica utente',
    deleteUser: 'Elimina utente',
    username: 'Nome utente',
    displayName: 'Nome visualizzato',
    email: 'E-mail',
    password: 'Password',
    role: 'Ruolo',
    roles: 'Ruoli',
    nation: 'Nazione',
    active: 'Attivo',
    lastLogin: 'Ultimo accesso',
    createdAt: 'Creato',
    isNation: 'Nazione',
    isEU: 'UE',
    isAdmin: 'Admin',
    isExcon: 'EXCON',
    isPlanner: 'Pianificatore',
    isHub: 'Hub',
    isReadOnly: 'Sola lettura',
    noUsers: 'Nessun utente trovato',
    confirmDelete: 'Conferma l\'eliminazione di questo utente?',
    resetPassword: 'Reimposta password',
    generatePassword: 'Genera password',
    searchUsers: 'Cerca utenti...',
    userCreated: 'Utente creato con successo',
    userUpdated: 'Utente aggiornato con successo',
    userDeleted: 'Utente eliminato con successo',
    selectNation: 'Selezionare una nazione',
    mustChangePassword: 'Deve cambiare la password al prossimo accesso',
    flagImage: 'Immagine della bandiera',
    exportUsers: 'Esporta utenti',
    importUsers: 'Importa utenti',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Mezzi di trasporto',
    createAsset: 'Crea mezzo',
    editAsset: 'Modifica mezzo',
    deleteAsset: 'Elimina mezzo',
    assetName: 'Nome del mezzo',
    assetType: 'Tipo di mezzo',
    capacitySeated: 'Capacità (seduti)',
    capacityLying: 'Capacità (sdraiati)',
    capacityIntensive: 'Capacità (terapia intensiva)',
    owner: 'Proprietario',
    operator: 'Operatore',
    baseLocation: 'Posizione base',
    range: 'Autonomia',
    speed: 'Velocità',
    noAssets: 'Nessun mezzo trovato',
    confirmDelete: 'Conferma l\'eliminazione di questo mezzo?',
    searchAssets: 'Cerca mezzi...',
    assetCreated: 'Mezzo creato con successo',
    assetUpdated: 'Mezzo aggiornato con successo',
    assetDeleted: 'Mezzo eliminato con successo',
    exportAssets: 'Esporta mezzi',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Hub',
    startPoints: 'Punti di partenza',
    createHub: 'Crea hub',
    editHub: 'Modifica hub',
    deleteHub: 'Elimina hub',
    hubName: 'Nome dell\'hub',
    hubType: 'Tipo di hub',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Hub di ingresso',
    airport: 'Aeroporto',
    seaport: 'Porto marittimo',
    railStation: 'Stazione ferroviaria',
    roadPoint: 'Punto stradale',
    ucpmClassification: 'Classificazione UCPM',
    icaoCode: 'Codice ICAO',
    iataCode: 'Codice IATA',
    noHubs: 'Nessun hub trovato',
    confirmDelete: 'Conferma l\'eliminazione di questo hub?',
    searchHubs: 'Cerca hub...',
    nationAssignment: 'Assegnazione alle nazioni',
    assignNations: 'Assegna nazioni',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Strutture sanitarie',
    createFacility: 'Crea struttura',
    editFacility: 'Modifica struttura',
    deleteFacility: 'Elimina struttura',
    facilityName: 'Nome della struttura',
    facilityType: 'Tipo di struttura',
    hospitalName: 'Nome dell\'ospedale',
    bedCapacity: 'Capacità posti letto',
    specialties: 'Specializzazioni',
    availableBeds: 'Posti letto disponibili',
    totalBeds: 'Posti letto totali',
    contactPerson: 'Persona di contatto',
    noFacilities: 'Nessuna struttura sanitaria trovata',
    confirmDelete: 'Conferma l\'eliminazione di questa struttura?',
    searchFacilities: 'Cerca strutture...',
    hubNationAssignment: 'Assegnazione hub-nazione',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Orari',
    createSchedule: 'Crea orario',
    editSchedule: 'Modifica orario',
    deleteSchedule: 'Elimina orario',
    scheduleName: 'Nome dell\'orario',
    scheduleType: 'Tipo di orario',
    recurring: 'Ricorrente',
    oneTime: 'Una tantum',
    frequency: 'Frequenza',
    daily: 'Giornaliera',
    weekly: 'Settimanale',
    startDate: 'Data di inizio',
    endDate: 'Data di fine',
    departureTime: 'Orario di partenza',
    arrivalTime: 'Orario di arrivo',
    stops: 'Fermate',
    addStop: 'Aggiungi fermata',
    noSchedules: 'Nessun orario trovato',
    bookings: 'Prenotazioni',
    timeline: 'Cronologia',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Notifiche',
    markAllRead: 'Segna tutto come letto',
    markAsRead: 'Segna come letto',
    markAsUnread: 'Segna come non letto',
    noNotifications: 'Nessuna notifica',
    viewAll: 'Visualizza tutte le notifiche',
    settings: 'Impostazioni notifiche',
    emailNotifications: 'Notifiche e-mail',
    inAppNotifications: 'Notifiche in-app',
    notifyOn: 'Avvisami per',
    requestCreated: 'Nuova richiesta',
    requestPublished: 'Richiesta pubblicata',
    requestClosed: 'Richiesta chiusa',
    requestCompleted: 'Richiesta completata',
    commentAdded: 'Nuovo commento',
    offerReceived: 'Offerta ricevuta',
    offerAccepted: 'Offerta accettata',
    statusChanged: 'Stato modificato',
    selectionStarted: 'Selezione avviata',
    missionCreated: 'Trasporto creato',
    missionStatusUpdated: 'Trasporto aggiornato',
    transportPartnerNamed: 'Partner di trasporto',
    transportExtensionReceived: 'Estensione del trasporto',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Impostazioni',
    general: 'Generale',
    system: 'Sistema',
    email: 'E-mail',
    sync: 'Sincronizzazione',
    security: 'Sicurezza',
    appearance: 'Aspetto',
    systemName: 'Nome del sistema',
    systemEmail: 'E-mail di sistema',
    maintenanceMode: 'Modalità manutenzione',
    readOnlyMode: 'Modalità sola lettura',
    emailEnabled: 'E-mail abilitata',
    smtpHost: 'Host SMTP',
    smtpPort: 'Porta SMTP',
    smtpUser: 'Utente SMTP',
    smtpPassword: 'Password SMTP',
    senderEmail: 'E-mail del mittente',
    senderName: 'Nome del mittente',
    testEmail: 'Invia e-mail di prova',
    syncEnabled: 'Sincronizzazione abilitata',
    syncUrl: 'URL di sincronizzazione',
    syncApiKey: 'Chiave API di sincronizzazione',
    settingsSaved: 'Impostazioni salvate con successo',
    helpdesk: 'Helpdesk',
    helpdeskTitle: 'Titolo helpdesk',
    helpdeskEmail: 'E-mail helpdesk',
    helpdeskPhone: 'Telefono helpdesk',
    helpdeskInfo: 'Informazioni helpdesk',
    realLifeSupport: 'Supporto in situazione reale',
    trainingMode: 'Modalità addestramento',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Registro di audit',
    action: 'Azione',
    user: 'Utente',
    target: 'Obiettivo',
    details: 'Dettagli',
    timestamp: 'Marca temporale',
    ipAddress: 'Indirizzo IP',
    noLogs: 'Nessun registro di audit trovato',
    searchLogs: 'Cerca nei registri...',
    filterByAction: 'Filtra per azione',
    filterByUser: 'Filtra per utente',
    exportLogs: 'Esporta registri',
    exportCsv: 'Esporta CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Controllo dell\'esercitazione',
    currentDay: 'Giorno attuale',
    exerciseDay: 'Giorno di esercitazione',
    nextDay: 'Giorno successivo',
    previousDay: 'Giorno precedente',
    resetExercise: 'Reimposta l\'esercitazione',
    startExercise: 'Avvia l\'esercitazione',
    endExercise: 'Termina l\'esercitazione',
    dayReset: 'Reimpostazione del giorno',
    confirmReset: 'Conferma la reimpostazione del giorno di esercitazione? Tutti i dati del giorno corrente verranno cancellati.',
    resetInProgress: 'Reimpostazione in corso...',
    maintenanceMode: 'Modalità manutenzione',
    enableMaintenance: 'Attiva la manutenzione',
    disableMaintenance: 'Disattiva la manutenzione',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Sincronizzazione dati',
    syncStatus: 'Stato della sincronizzazione',
    lastSync: 'Ultima sincronizzazione',
    pendingItems: 'Elementi in attesa',
    syncNow: 'Sincronizza ora',
    syncing: 'Sincronizzazione in corso...',
    syncSuccess: 'Sincronizzazione completata con successo',
    syncFailed: 'Sincronizzazione non riuscita',
    outbox: 'Posta in uscita',
    inbox: 'Posta in arrivo',
    configuration: 'Configurazione',
    targetUrl: 'URL di destinazione',
    apiKey: 'Chiave API',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Mappa',
    layers: 'Livelli',
    requests: 'Richieste',
    hubs: 'Hub',
    facilities: 'Strutture',
    routes: 'Percorsi',
    showAll: 'Mostra tutto',
    hideAll: 'Nascondi tutto',
    zoomIn: 'Ingrandisci',
    zoomOut: 'Riduci',
    resetView: 'Reimposta vista',
    satellite: 'Satellite',
    terrain: 'Terreno',
    offline: 'Offline',
    online: 'Online',
    tilesOffline: 'Le tessere della mappa sono servite localmente',
    tilesOnline: 'Le tessere della mappa sono caricate da server online',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Statistiche',
    overview: 'Panoramica',
    requestsByStatus: 'Richieste per stato',
    requestsByCategory: 'Richieste per categoria',
    requestsByNation: 'Richieste per nazione',
    offersByStatus: 'Offerte per stato',
    patientsByCondition: 'Pazienti per condizione',
    transportsByStatus: 'Trasporti per stato',
    timeline: 'Cronologia',
    totalRequests: 'Totale richieste',
    totalOffers: 'Totale offerte',
    totalPatients: 'Totale pazienti',
    totalTransports: 'Totale trasporti',
    averageResponseTime: 'Tempo medio di risposta',
    completionRate: 'Tasso di completamento',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Statistiche dell\'esercitazione',
    overview: 'Panoramica',
    byCategory: 'Per categoria',
    byNation: 'Per nazione',
    byDay: 'Per giorno',
    totalPatientsMoved: 'Totale pazienti trasferiti',
    totalRequestsProcessed: 'Totale richieste elaborate',
    averageProcessingTime: 'Tempo medio di elaborazione',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Diagramma di flusso',
    sankey: 'Sankey',
    nodeGraph: 'Grafo a nodi',
    refresh: 'Aggiorna',
    noData: 'Nessun dato di flusso disponibile',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'Informazioni',
    version: 'Versione',
    systemInfo: 'Informazioni di sistema',
    buildDate: 'Data di compilazione',
    environment: 'Ambiente',
    description: 'ARCOS — Sistema avanzato di comunicazione delle richieste',
    subtitle: 'Assistenza alle vittime e operazioni mediche',
    whatIsArcos: 'Cos\'è ARCOS? – Spiegazione per i partecipanti all\'esercitazione',
    arcosDesc1: 'ARCOS è uno strumento digitale utilizzato in questa esercitazione per supportare e strutturare la comunicazione internazionale, le richieste e i processi di coordinamento tra gli attori partecipanti.',
    arcosDesc2: 'ARCOS fornisce una rappresentazione semplificata e orientata all\'esercitazione dei principi di base di questi sistemi.',
    arcosUsedFor: 'Durante l\'esercitazione, ARCOS viene utilizzato per rappresentare processi tipici come:',
    arcosUsedForItem1: 'presentazione e gestione di richieste di assistenza,',
    arcosUsedForItem2: 'coordinamento e risposta alle offerte di supporto di altre nazioni,',
    arcosUsedForItem3: 'monitoraggio dello stato e dell\'avanzamento delle richieste,',
    arcosUsedForItem4: 'e rappresentazione semplificata dei flussi di trasporto o evacuazione.',
    arcosDesc3: 'I flussi di lavoro in ARCOS sono intenzionalmente semplificati e adattati agli obiettivi formativi specifici dell\'esercitazione.',
    arcosDesc4: 'L\'obiettivo di ARCOS non è simulare un sistema reale perfetto o completo.',
    arcosDesc5: 'Se certi elementi differiscono dalle procedure reali che potreste conoscere, questo è previsto.',
    facilitatedBy: 'Facilitato da MMCC-E',
    dhcInitiative: 'Il Digital Health Corner (DHC) è un\'iniziativa congiunta di:',
    dhcAuthor1: 'Sven Giegerich — Forze Armate Tedesche',
    dhcAuthor2: 'Mohamad Haji — Difesa Belga',
    dhcConviction: 'Nata dalla convinzione che l\'innovazione prospera dove la passione incontra il pragmatismo.',
    dhcInspired: 'Ispirati dalla scintilla iniziale del MMCC-E, ci siamo proposti di creare soluzioni semplici ma efficaci.',
    dhcLove: 'Lo facciamo perché amiamo il nostro lavoro e crediamo che le idee digitali possano rimodellare la collaborazione nella sanità militare.',
    dhcOpen: 'Il DHC è una piattaforma aperta: libera da gerarchie, aperta alle idee, guidata dalla curiosità.',
    dhcClosing: 'Digital Health Corner – dove la curiosità incontra la collaborazione.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Documentazione',
    gettingStarted: 'Per iniziare',
    userGuide: 'Guida utente',
    faq: 'FAQ',
    troubleshooting: 'Risoluzione dei problemi',
    apiReference: 'Riferimento API',
    downloadTemplate: 'Scarica modello',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Importazione pazienti',
    uploadFile: 'Carica file',
    selectFile: 'Seleziona file',
    preview: 'Anteprima',
    importNow: 'Importa ora',
    importing: 'Importazione in corso...',
    importSuccess: '{{count}} pazienti importati con successo',
    importFailed: 'Importazione non riuscita',
    downloadTemplate: 'Scarica modello',
    dragDrop: 'Trascinare un file qui, oppure cliccare per selezionare',
    supportedFormats: 'Formati supportati: XLSX, XLS, CSV',
    rowsFound: '{{count}} righe trovate',
    validRows: '{{count}} righe valide',
    invalidRows: '{{count}} righe non valide',
    duplicateRows: '{{count}} righe duplicate',
    previewData: 'Anteprima dati',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Pianificazione trasporti',
    planRoute: 'Pianifica percorso',
    routeBuilder: 'Costruttore di percorso',
    addWaypoint: 'Aggiungi tappa',
    removeWaypoint: 'Rimuovi tappa',
    estimatedDuration: 'Durata stimata',
    distance: 'Distanza',
    selectVehicle: 'Seleziona veicolo',
  },

  transportBooking: {
    title: 'Prenotazione trasporti',
    bookTransport: 'Prenota trasporto',
    availableSlots: 'Posti disponibili',
    bookingConfirmed: 'Prenotazione confermata',
    cancelBooking: 'Annulla prenotazione',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Pianificazione capacità',
    totalCapacity: 'Capacità totale',
    usedCapacity: 'Capacità utilizzata',
    availableCapacity: 'Capacità disponibile',
    utilizationRate: 'Tasso di utilizzo',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Modelli mezzi',
    dayTemplates: 'Modelli giornalieri',
    createTemplate: 'Crea modello',
    editTemplate: 'Modifica modello',
    deleteTemplate: 'Elimina modello',
    templateName: 'Nome del modello',
    applyTemplate: 'Applica modello',
    noTemplates: 'Nessun modello trovato',
    confirmDelete: 'Conferma l\'eliminazione di questo modello?',
    confirmApply: 'Conferma l\'applicazione di questo modello? I dati esistenti verranno sovrascritti.',
    exportTemplates: 'Esporta modelli',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Barra annunci',
    createAnnouncement: 'Crea annuncio',
    editAnnouncement: 'Modifica annuncio',
    deleteAnnouncement: 'Elimina annuncio',
    message: 'Messaggio',
    startTime: 'Orario di inizio',
    endTime: 'Orario di fine',
    active: 'Attivo',
    noAnnouncements: 'Nessun annuncio',
    confirmDelete: 'Conferma l\'eliminazione di questo annuncio?',
  },

  // ============================================================
  // COMPONENTS — Stringhe dei componenti riutilizzabili
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Cerca...',
      noResults: 'Nessun risultato trovato',
      showing: 'Visualizzazione da {{from}} a {{to}} di {{total}}',
      rowsPerPage: 'Righe per pagina',
      previousPage: 'Pagina precedente',
      nextPage: 'Pagina successiva',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Conferma',
      cancel: 'Annulla',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Modifiche non salvate',
      message: 'Sono presenti modifiche non salvate. Conferma di voler uscire da questa pagina?',
      stay: 'Resta sulla pagina',
      leave: 'Esci dalla pagina',
    },
    // EmptyState
    emptyState: {
      noData: 'Nessun dato disponibile',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Si è verificato un errore',
      message: 'Si è verificato un errore imprevisto. Provare ad aggiornare la pagina.',
      retry: 'Riprova',
    },
    // ExportButton
    exportButton: {
      export: 'Esporta',
      exporting: 'Esportazione in corso...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Stampa',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Bozza',
      review: 'Revisione',
      published: 'Pubblicata',
      selection: 'Selezione',
      inTransit: 'In transito',
      completed: 'Completata',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Istanza online',
      message: 'Modalità sola lettura. I dati sono sincronizzati dal server principale.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Visualizzazione come',
      loggedInAs: 'connesso come {{nation}}',
      returnTo: 'Torna a {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Cerca pagine, richieste, trasporti...',
      searching: 'Ricerca in corso...',
      noResults: 'Nessun risultato per "{{query}}"',
      navigate: 'Naviga',
      select: 'Seleziona',
      close: 'Chiudi',
      pages: {
        dashboard: 'Dashboard',
        requests: 'Richieste',
        transports: 'Trasporti',
        map: 'Mappa',
        myPatients: 'I miei pazienti',
        flowDiagram: 'Diagramma di flusso',
        statistics: 'Statistiche',
        assets: 'Mezzi di trasporto',
        startPoints: 'Punti di partenza / Hub',
        treatmentFacilities: 'Strutture sanitarie',
        users: 'Utenti',
        settings: 'Impostazioni',
        auditLogs: 'Registro di audit',
        exerciseControl: 'Controllo dell\'esercitazione',
        dataSync: 'Sincronizzazione dati',
        patientImport: 'Importazione pazienti',
        notifications: 'Notifiche',
        documentation: 'Documentazione',
      },
      actions: {
        importPatientsJson: 'Importa Pazienti (JSON)',
        importPatientsExcel: 'Importa Pazienti (Excel)',
        importUsers: 'Importa Utenti (Excel)',
        importAssetTemplates: 'Importa Modelli di Asset (Excel)',
        importDayTemplates: 'Importa Voci Modello Giornaliero (Excel)',
        exportRequests: 'Esporta Richieste (Excel)',
        exportPatients: 'Esporta Pazienti (Excel)',
        exportUsers: 'Esporta Utenti (Excel)',
        exportCredentials: 'Esporta Credenziali (PDF)',
        exportAuditExcel: 'Esporta Registro audit (Excel)',
        exportAuditPdf: 'Esporta Registro audit (PDF)',
        pagePatientImport: 'Pagina importazione pazienti',
        pageRequestDetail: 'Pagina dettaglio richiesta',
        pageUsers: 'Pagina gestione utenti',
        pageAssetTemplates: 'Pagina modelli di asset',
        pageDayTemplates: 'Pagina modelli giornalieri',
        pageRequests: 'Pagina elenco richieste',
        pageAuditLogs: 'Pagina registro audit',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Sessione in scadenza',
      message: 'La Sua sessione scadrà tra <strong>{{time}}</strong>. Salvi il lavoro e acceda nuovamente per continuare.',
      dismiss: 'Chiudi',
      logoutNow: 'Esci ora',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Selezionare 4 fusi orari',
      configure: 'Configura fusi orari',
      reset: 'Ripristina',
      apply: 'Applica',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Seleziona posizione',
      latitude: 'Latitudine',
      longitude: 'Longitudine',
      clickToSelect: 'Cliccare sulla mappa per selezionare una posizione',
    },
    // Modal
    modal: {
      close: 'Chiudi',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Home',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Manutenzione del sistema',
    message: 'Il sistema è in fase di reimpostazione per il prossimo giorno di esercitazione. Attendere il completamento del processo.',
    autoRefresh: 'Questa pagina si aggiornerà automaticamente quando il sistema sarà nuovamente disponibile.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Almeno 10 caratteri',
    uppercase: '1 lettera maiuscola',
    lowercase: '1 lettera minuscola',
    digit: '1 cifra',
    special: '1 carattere speciale',
  },
};

export default it;
